import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BRAND = "JJS Engagement";
const TITLES = {
  "/": "Jaipur Jewellery Show",
  "/staff/login": "Login",
  "/visitor/login": "Visitor Login",
  "/sv-admin": "Admin Login",
  "/visitor": "Exhibitors",
  "/visitor/scan": "Scan",
  "/visitor/history": "My Visits",
  "/visitor/favourites": "Saved",
  "/visitor/summary": "My Summary",
  "/exhibitor": "Dashboard",
  "/exhibitor/catalogues": "Catalogues",
  "/exhibitor/leads": "Leads",
  "/exhibitor/scan": "Scan Badge",
  "/exhibitor/staff": "Staff",
  "/exhibitor/qr": "My QR Code",
  "/exhibitor/followups": "Follow-ups",
  "/exhibitor/networking": "Networking",
  "/exhibitor/enquiries": "Enquiries",
  "/exhibitor/products": "Product Library",
  "/admin": "Admin Dashboard",
  "/superadmin": "Super Admin",
};

function titleFor(path) {
  if (TITLES[path]) return TITLES[path];
  if (path.startsWith("/exhibitor/leads/")) return "Lead";
  if (path.startsWith("/visitor/exhibitor/")) return "Exhibitor";
  if (path.startsWith("/share/")) return "Catalogue";
  return null;
}

export default function PageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const t = titleFor(pathname);
    document.title = t ? `${t} · ${BRAND}` : BRAND;
  }, [pathname]);
  return null;
}
